import {AsyncButton, Button, ButtonGroup} from "@client/components/Button";
import {DateCarousel} from "@client/components/DateCarousel";
import {FuelMealsMark} from "@client/components/FuelMealsMark";
import {RatingRequest} from "@client/components/RatingRequest";
import {RegisterRequest} from "@client/components/RegisterRequest";
import {TourCard} from "@client/components/TourCard";
import {useCapture} from "@client/features/camera";
import {notify} from "@client/features/notifications";
import * as widgets from "@client/forms/widgets";
import * as journeys from "@client/journeys";
import * as router from "@client/router";
import * as typography from "@client/shared/typography";
import {useSiteContext} from "@client/site/context";
import {useAppDispatch} from "@client/store";
import * as utils from "@client/utils";
import React from "react";

const onClick = () => alert("Clicked");

const TEXT_AREA_CONTENT = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum eu hendrerit augue. Nunc commodo, neque vitae laoreet pretium, velit risus dapibus turpis, vel ultricies eros augue eu nunc. Mauris a finibus purus. Maecenas non ex nec augue venenatis facilisis ut a augue. Nullam tempus risus sit amet orci finibus, vel hendrerit velit vulputate. Aenean rhoncus dolor mi, vestibulum pulvinar nulla feugiat non. Morbi varius feugiat ante, eget finibus odio porta vitae.

Nulla facilisi. Donec sollicitudin nulla mi, ut consectetur risus luctus non. Maecenas id aliquam sapien. Nam varius sem cursus velit semper, eu iaculis est dictum. Aliquam maximus, leo a vestibulum interdum, libero libero dapibus dui, sit amet semper lectus libero at tortor. Maecenas venenatis, erat at consectetur ullamcorper, lectus quam imperdiet lacus, a malesuada massa tellus nec risus. Cras tincidunt lorem ac luctus scelerisque. In ac justo blandit nisl ornare finibus.

Vestibulum a ex a magna porttitor mattis. Cras finibus urna pellentesque, lacinia turpis nec, gravida nisl. Aliquam nisl felis, suscipit sit amet posuere et, iaculis sit amet nisi. Mauris maximus eget sapien commodo volutpat. Nullam faucibus dui vitae venenatis ornare. Curabitur lacinia quis tellus non tincidunt. Morbi non enim molestie, pellentesque sapien vel, pretium mi. Donec eget placerat nunc, a iaculis nisi. Fusce commodo fermentum tortor, vitae pulvinar tortor vulputate eu.
`;

const QUICK_SELECT_OPTIONS = [
    {value: "FIRST", label: "Longer option"},
    {value: "SECOND", label: "Second"},
    {value: "THIRD", label: "Third"},
    {value: "FOURTH", label: "Fourth"},
    {value: "FIFTH", label: "Fifth"},
];

export const Storyboard = router.Storyboard.withHooks(() => {
    const [useSimpleShell, setUseSimpleShell] = React.useState(false);
    return {useSimpleShell, setUseSimpleShell};
})
    .withIndex(({useSimpleShell, setUseSimpleShell}) => {
        const callback = () => {};
        const dispatch = useAppDispatch();

        const context = useSiteContext();
        const exerciseDialog = journeys.useExercisesDialog();
        const capture = useCapture({
            target: null,
            profile: context.profile!,
            cameraEnabled: false,
        });

        const [forceLoading, setForceLoading] = React.useState(false);
        const [importantActionLoading, setImportantActionLoading] =
            React.useState(false);

        return (
            <div>
                <h1>Tour card</h1>
                <div className="my-4" id="tour-cards">
                    <TourCard
                        title={
                            <>
                                <FuelMealsMark /> are loaded
                            </>
                        }
                        onDismiss={callback}
                    >
                        Search for anything else
                    </TourCard>
                </div>
                <h1>Notifications</h1>
                <div className="my-4 flex flex-wrap gap-2">
                    <button
                        className={`rounded-sm px-4 py-2 text-white ${useSimpleShell ? "bg-indigo-600" : "bg-gray-400"} `}
                        onClick={() => setUseSimpleShell(!useSimpleShell)}
                    >
                        {useSimpleShell ? "Using SimpleScene" : "Using Scene"}
                    </button>
                </div>
                <div className="my-4 flex flex-wrap gap-2">
                    <button
                        className="rounded-sm bg-green-500 px-4 py-2 text-white"
                        onClick={() =>
                            dispatch(notify("Success temporary!", {type: "success"}))
                        }
                    >
                        Success (temporary)
                    </button>
                    <button
                        className="rounded-sm bg-green-700 px-4 py-2 text-white"
                        onClick={() =>
                            dispatch(
                                notify("Success permanent!", {
                                    type: "success",
                                    permanent: true,
                                }),
                            )
                        }
                    >
                        Success (permanent)
                    </button>
                    <button
                        className="rounded-sm bg-red-500 px-4 py-2 text-white"
                        onClick={() =>
                            dispatch(notify("Error temporary!", {type: "error"}))
                        }
                    >
                        Error (temporary)
                    </button>
                    <button
                        className="rounded-sm bg-red-700 px-4 py-2 text-white"
                        onClick={() =>
                            dispatch(
                                notify("Error permanent!", {
                                    type: "error",
                                    permanent: true,
                                }),
                            )
                        }
                    >
                        Error (permanent)
                    </button>
                </div>
                <h1>ImportantAction - Force Loading Demo</h1>
                <div className="my-4 space-y-2">
                    <typography.ImportantAction
                        title="Important Action (Large Button)"
                        subtitle="This is a subtitle to demonstrate the large button"
                        onClick={async () => {
                            await utils.delay(100);
                            alert("Important action completed!");
                        }}
                        forceLoading={importantActionLoading}
                    />
                    <div>
                        <button
                            className="mr-2 rounded-sm bg-gray-300 px-4 py-2"
                            onClick={() => {
                                setImportantActionLoading(true);
                                setTimeout(() => setImportantActionLoading(false), 100);
                            }}
                        >
                            Toggle Force Loading Fast (100ms)
                        </button>
                        <button
                            className="rounded-sm bg-gray-300 px-4 py-2"
                            onClick={() => {
                                setImportantActionLoading(true);
                                setTimeout(
                                    () => setImportantActionLoading(false),
                                    2000,
                                );
                            }}
                        >
                            Toggle Force Loading Slow (2s)
                        </button>
                    </div>
                </div>
                <div className="my-4">
                    {exerciseDialog.dialog}
                    <button onClick={() => exerciseDialog({})}>
                        Open exercise dialog
                    </button>
                </div>
                <div className="my-4">
                    {capture.dialog}
                    <button
                        onClick={async () => {
                            const result = await capture.start({
                                initialView: "manual",
                                cameraMode: "barcode_only",
                            });

                            if (result.type === "entries") {
                                console.log(result.entries);
                            }
                        }}
                    >
                        Open entry dialog
                    </button>
                </div>
                <h1>AsyncButton - Fast Promise (100ms)</h1>
                <div className="my-4">
                    <AsyncButton
                        className="rounded-lg bg-indigo-600 px-4 py-2 text-white"
                        onClick={async () => {
                            await utils.delay(100);
                            alert("Fast promise completed!");
                        }}
                    >
                        Fast Promise (100ms - no spinner)
                    </AsyncButton>
                </div>
                <h1>AsyncButton - Slow Promise (1000ms)</h1>
                <div className="my-4">
                    <AsyncButton
                        className="rounded-lg bg-indigo-600 px-4 py-2 text-white"
                        onClick={async () => {
                            await utils.delay(1000);
                            alert("Slow promise completed!");
                        }}
                    >
                        Slow Promise (1000ms - shows spinner)
                    </AsyncButton>
                </div>
                <h1>AsyncButton - Force Loading (Toggle)</h1>
                <div className="my-4 space-y-2">
                    <AsyncButton
                        className="rounded-lg bg-indigo-600 px-4 py-2 text-white"
                        forceLoading={forceLoading}
                    >
                        Force Loading Demo
                    </AsyncButton>
                    <div>
                        <button
                            className="mr-2 rounded-sm bg-gray-300 px-4 py-2"
                            onClick={() => {
                                setForceLoading(true);
                                setTimeout(() => setForceLoading(false), 100);
                            }}
                        >
                            Toggle Force Loading Fast (100ms)
                        </button>
                        <button
                            className="rounded-sm bg-gray-300 px-4 py-2"
                            onClick={() => {
                                setForceLoading(true);
                                setTimeout(() => setForceLoading(false), 2000);
                            }}
                        >
                            Toggle Force Loading Slow (2s)
                        </button>
                    </div>
                </div>
                <h1>Date carousel</h1>
                <div>
                    <DateCarousel
                        previousDayLink=""
                        onDateClick={onClick}
                        nextDayLink=""
                        date="2020-04-29"
                        onPreviousClick={onClick}
                    />
                </div>
                <h1>Button</h1>
                <div>
                    <Button href="">Link button</Button>
                </div>
                <div>
                    <Button onClick={onClick}>Button button</Button>
                </div>
                <h1>Button group</h1>
                <ButtonGroup>
                    <Button href="">Link button</Button>
                    <Button onClick={onClick}>Button button</Button>
                </ButtonGroup>
                <RegisterRequest />
                <RatingRequest
                    isAskingForRating="feedback"
                    answerFeelerPositively={callback}
                    // agreeToRate={callback}
                    declineToRate={callback}
                    agreeToProvideFeedBack={callback}
                    declineToProvideFeedBack={callback}
                    answerFeelerNegatively={callback}
                />

                <typography.Prose>
                    <p>Some paragraph text about subscription.</p>
                    <p>Paid subscriptions keep Joy ad-free.</p>
                    <typography.ButtonGroup>
                        <typography.Button onClick={callback}>
                            Purchase subscription
                        </typography.Button>
                        <typography.Button onClick={callback}>
                            Restore Purchases
                        </typography.Button>
                    </typography.ButtonGroup>
                </typography.Prose>
                <h1>Textarea</h1>
                <widgets.TextArea
                    name=""
                    onChange={callback}
                    readOnly={false}
                    value={TEXT_AREA_CONTENT}
                />
                <h1>Read only textarea</h1>
                <widgets.TextArea
                    name=""
                    onChange={callback}
                    readOnly
                    value={TEXT_AREA_CONTENT}
                />
                <h1>Quick select</h1>
                <widgets.QuickSelect
                    onChange={callback}
                    type="text"
                    name="quick"
                    options={QUICK_SELECT_OPTIONS}
                    value="FOURTH"
                    shrinkLast={false}
                />
                <h1>Disabled quick select</h1>
                <widgets.QuickSelect
                    onChange={callback}
                    name="quick_disabled"
                    type="text"
                    readOnly
                    options={QUICK_SELECT_OPTIONS}
                    value="FOURTH"
                    shrinkLast={false}
                />
                <h1>Evenly-spaced quick select</h1>
                <widgets.QuickSelect
                    onChange={callback}
                    name="quick_even"
                    type="text"
                    options={QUICK_SELECT_OPTIONS}
                    value="FIRST"
                    shrinkLast="even"
                />
                <h1>Check off</h1>
                <widgets.Checkbox
                    onChange={() => alert("Would turn on")}
                    name="quick_even"
                    value={false}
                />
                <h1>Check on</h1>
                <widgets.Checkbox
                    onChange={() => alert("Would turn off")}
                    name="quick_even"
                    value
                />
                <h1>Flush input (Search)</h1>
                <widgets.TextInput
                    name=""
                    flush
                    readOnly={false}
                    placeholder="I am a placeholder"
                    onChange={callback}
                    value={""}
                    spellCheck={false}
                />
            </div>
        );
    })
    .withActions(() => [])
    .withOptions(({useSimpleShell}) => ({
        title: "Storyboard",
        scene: useSimpleShell ? ({kind: "SIMPLE"} as const) : undefined,
    }));
